<template>
	<div
		class="cart-items-group bgr-blue">
		<div class="mb-2">
			<span>Dikirim dari: </span>
			<span class="text-bold">{{ getSubdistrictName(group.originId) }}</span>
		</div>
		<div
			class="row">
			<div class="col-sm-6">
				<!-- Courier -->
				<div class="form-group mb-2">
					<label><b>Courier</b></label>
					<multiselect
						placeholder="Shipping Courier"
						label="name"
						track-by="code"
						v-model="courier"
						:options="couriers"
						:show-labels="false"
						:allow-empty="false"
						:loading="isFetchingShipping"
						:disabled="couriers.length === 0"
						@select="onCourierChange">
					</multiselect>
				</div>
			</div>
			<div class="col-sm-6">
				<!-- Package -->
				<div class="form-group mb-2">
					<label><b>Package</b></label>
					<multiselect
						placeholder="Shipping Package"
						label="label"
						track-by="service"
						v-model="shippingPackage"
						:options="shippingPackages"
						:show-labels="false"
						:allow-empty="false"
						:loading="isFetchingShipping"
						:disabled="shippingPackages.length === 0"
						@select="onPackageChange">
					</multiselect>
				</div>
			</div>
		</div>
		<div class="cart-items card">
			<cart-item
				v-for="(cartItem, cartIndex) in group.items"
				:key="cartIndex"
				:products="products"
				:item="cartItem"
				:index="cartIndex"
				@change="onChange"
				@remove="remove(cartItem)">
			</cart-item>
		</div>
	</div>
</template>

<script>
import CartItem from '@/components/CartItem.vue';
import shipping from '../api/shipping';
import { duplicateVar, formatMoney } from '../lib/helper';
import { shippingCouriers } from '../lib/statics';

export default {
	name: 'CartGroup',
	props: {
		group: {
			type: Object,
		},
		products: {
			type: Array,
			default: () => [],
		},
		subdistricts: {
			type: Array,
			default: () => [],
		},
		shippingCosts: {
			type: Array,
			default: () => [],
		},
		destinationId: {
			type: Number,
		},
	},
	components: {
		CartItem,
	},
	data() {
		return {
			courier: null,
			couriers: [],
			shippingPackage: null,
			shippingPackages: [],
			isFetchingShipping: false,
		};
	},
	methods: {
		onChange(item) {
			this.getShippingService();
			this.$emit('change', item);
		},
		remove(cartItem) {
			if (this.group.items.length === 1) {
				this.removeShipping();
			}
			this.$emit('remove', cartItem);
		},
		removeShipping() {
			const originId = this.group.originId;
			this.$emit('remove-shipping', originId);
		},
		getSubdistrictName(subdistrictId) {
			const subdstrict = this.subdistricts.find((subdstrict) => {
				const isSame = subdstrict.subdistrict_id === subdistrictId;
				return isSame;
			});
			// const subdistrictName = subdstrict ? subdstrict.subdistrict_name : '-';
			const subdistrictName = subdstrict ? subdstrict.city : '-';
			return subdistrictName;
		},
		onCourierChange(courier, setPackage = false) {
			this.shippingPackage = null;
			this.shippingPackages = [];
			const formatter = (cost) => {
				const shippingCost = cost.cost[0].value;
				const shippingCostFormatted = formatMoney(shippingCost);
				if (cost.service === 'CTC') {
					cost.service = 'REG';
				} else if (cost.service === 'CTCYES') {
					cost.service = 'YES';
				}
				const label = `${cost.service} (${shippingCostFormatted})`;
				cost.label = label;
				return cost;
			};
			const costs = courier.costs.map(formatter);
			this.shippingPackages = duplicateVar(costs);
			if (setPackage) {
				this.setShippingPackage();
			}
		},
		onPackageChange(shippingPackage) {
			if (shippingPackage) {
				const courier = this.courier.code;
				const originId = this.group.originId;
				this.$emit('change-shipping', { courier, shippingPackage, originId });
			}
		},
		getShippingService() {
			this.isFetchingShipping = true;
			const originData = JSON.stringify(this.origin);
			const destinationData = JSON.stringify(this.destination);
			const couriersData = JSON.stringify(this.shippingCouriers);
			const productData = JSON.stringify({
				weight: this.totalWeight,
			});
			const params = {
				origin: originData,
				destination: destinationData,
				couriers: couriersData,
				product: productData,
			};
			const callback = (response) => {
				const couriers = response.data;
				this.couriers = couriers;
				this.setCourier();
				this.isFetchingShipping = false;
			};
			const errCallback = () => {
				this.isFetchingShipping = false;
			};
			shipping.getCosts(params, callback, errCallback);
		},
		setCourier() {
			let courierCode = this.shippingCost.courier;
			if (courierCode === 'jnt') {
				courierCode = 'J&T';
			}
			const courier = this.couriers.find(({ code }) => code === courierCode);
			if (courier) {
				this.courier = courier;
				this.onCourierChange(courier, true);
			}
		},
		setShippingPackage() {
			const shippingPackages = this.shippingPackages;
			let serviceCode = this.shippingCost.service;
			if (serviceCode === 'CTC') {
				serviceCode = 'REG';
			} else if (serviceCode === 'CTCYES') {
				serviceCode = 'YES';
			}
			const shippingPackage = shippingPackages.find(({ service }) => service === serviceCode);
			if (shippingPackage) {
				this.shippingPackage = shippingPackage;
				this.onPackageChange(shippingPackage);
			}
		},
	},
	computed: {
		origin() {
			const origin = {
				id: this.group.originId,
				type: 'subdistrict',
			};
			return origin;
		},
		destination() {
			const destination = {
				id: this.destinationId,
				type: 'subdistrict',
			};
			return destination;
		},
		shippingCouriers() {
			// // eslint-disable-next-line
			// const productIds = this.group.items.map(({ product_id }) => product_id.$oid);
			// // eslint-disable-next-line
			// const products = this.products.filter(({ product_id }) => productIds.includes(product_id.$oid));
			const couriers = shippingCouriers.map(({ key }) => key);
			return couriers;
		},
		totalWeight() {
			let totalWeight = 0;
			this.group.items.forEach(({ weight, qty }) => {
				totalWeight += qty * weight;
			});
			return totalWeight;
		},
		shippingCost() {
			const cost = this.shippingCosts.find(({ origin }) => origin.id === this.group.originId);
			return cost;
		},
	},
	created() {
		this.getShippingService();
	},
};
</script>

<style>

</style>
